import React, { useContext, useState } from "react";
import { Button } from "reactstrap";
import GenericModal from "../common/GenericModal";
import { RootStoreContext } from "../../app/stores/rootStore";
import { QrReaderContainer } from "./QrReaderContainer";
import { translationHookOptions } from "../../app/localization/localization";
import { useTranslation } from "react-i18next";
import { codeQuerystringParameter } from "../../app/helpers/urlHelper";

const ConnectUsingQRCodeButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { connectToScreen } = rootStore.screensStore;
  const [isQRReaderOpen, setIsQRReaderOpen] = useState(false);
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleConnection = (data: string) => {
    if (data) {
      let code = "";
      try {
        const urlParams = new URL(data).searchParams;
        if (urlParams.has(codeQuerystringParameter))
          code = urlParams.get(codeQuerystringParameter)!;
      } catch (error) {}

      if (!code) code = data;
      connectToScreen(code).finally(() => setIsQRReaderOpen(false));
    }
  };

  return (
    <>
      <Button
        className="screenQrButton"
        onClick={() => setIsQRReaderOpen(true)}
      >
        <i className="fas fa-webcam fa-4x screenQrIcon"></i>
        <h5 className="mb-0">{t("screens_new_connect_fromqr_button")}</h5>
      </Button>
      <GenericModal
        title={t("screens_new_connect_fromqr_modal_title")}
        isOpen={isQRReaderOpen}
        toggle={() => setIsQRReaderOpen(!isQRReaderOpen)}
        content={
          <>
            <QrReaderContainer handleConnection={handleConnection} />
          </>
        }
        actions={[]}
        size="md"
      />
    </>
  );
};

export default ConnectUsingQRCodeButton;
